// @flow

import React, { type ComponentType } from "react";
import { connect } from "react-redux";
import ErrorPage from "./error-page";
import { fireEvent, AppEvent } from "@modules/app-events";

type Props = $Exact<{
  alternativeErrorPage?: any,
}>;

type State = $Exact<{
  hasError: boolean,
  error: string | null,
}>;

function withErrorHandler(props?: Props) {
  return (WrappedComponent: ComponentType<any>) => {
    type PropsFromDispatch = $Exact<{
      fireEvent: typeof fireEvent,
    }>;

    class WithErrorHandler extends React.Component<PropsFromDispatch, State> {
      state = {
        hasError: false,
        error: null,
      };

      static getDerivedStateFromError(error: Error) {
        return { hasError: true, error: error.toString() };
      }

      componentDidCatch(error: Error, info: Object) {
        let event = AppEvent.error();
        event.add("error", error.toString());
        event.add("stack", info.componentStack);
        this.props.fireEvent(event);
      }

      render() {
        if (!this.state.hasError) {
          return <WrappedComponent {...this.props} />;
        }

        if (props && props.alternativeErrorPage) {
          const { alternativeErrorPage: ErrorPage } = props.alternativeErrorPage;
          return <ErrorPage {...props} {...this.props} error={this.state.error} />;
        }

        return <ErrorPage {...props} {...this.props} error={this.state.error} />;
      }
    }

    const mapDispatchToProps = {
      fireEvent,
    };

    return connect(null, mapDispatchToProps)(WithErrorHandler);
  };
}

export default withErrorHandler;
